<template>
    <div>
        <!-- 表格 -->
        <el-table class="columnClassNav" align="center" :data="tableData" border>
            <el-table-column label="用户id" prop="userid" align="center">
            </el-table-column>

            <el-table-column label="用户昵称" prop="nickName" align="center">
                <template slot-scope="tableData">
                    {{ nickName || '--' }}
                </template>
            </el-table-column>

            <el-table-column label="变动数量" prop="changeAmount" align="center">
                <template slot-scope="tableData">
                    <span :style="{ color: tableData.row.type == 'INCREASE' ? '#5eb95e' : '#f04134' }">
                        <span>{{ tableData.row.type == 'INCREASE' ? '+' : '-' }}</span>
                        <span>{{ tableData.row.changeAmount }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="积分变动业务" prop="sourceType" align="center">
                <template slot-scope="tableData">
                    <el-tag>
                        {{ sourceTypeText(tableData.row.sourceType) }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="变动前积分" align="center" prop="beforeAmount">
            </el-table-column>

            <el-table-column prop="afterAmount" label="变动后积分" align="center">
            </el-table-column>

            <el-table-column prop="createTime" label="变动时间" align="center">
            </el-table-column>
        </el-table>

        <div style="text-align: right;margin: 20px 20px 0 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import '@/assets/icon/iconfont.css'
import { getPointsRecordPage } from '@/api/withdraw'
export default {
    name: 'pointsRecordList',
    props: {
        userId: { type: Number, default: 0 },
        nickName: { type: String, default: '' },
    },
    data() {
        return {
            tableData: '',
            total_pages: 0,
            params: { pageNum: 1, pageSize: 10 },
        }
    },
    created() {
        this.getData()
    },
    methods: {
        sourceTypeText(type) {
            const map = {
                POST_CONTENT: '发布帖子',
                REPLY_CONTENT: '回复帖子',
                REPLY_COMMENT: '回复评论',
                LIKE_CONTENT: '点赞帖子',
                COLLECTION_CONTENT: '帖子收藏',
                SHARE_CONTENT: '帖子分享',
                GIVE_GIFT: '赠送礼物',
                WALLET_RECHARGE: '钱包充值',
                FOLLOW_USER: '关注用户',
                BUY_GOODS: '购买商品',
                BUY_VIP: '购买会员',
                LOOK_AD: '观看广告',
                SIGN_IN: '每日签到',
                INVITE_FRIEND: '邀请好友',
                RECHARGE: '钱包充值',
                WITHDRAW: '提现',
                RECEIVE_GIFT: '接收礼物',
                SYSTEM_OPERATE: '系统操作',
                TASK: '任务奖励'
            };
            return map[type] || '未知';
        },
        getData() {
            this.params.userId = this.userId;
            getPointsRecordPage(this.params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.total_pages = res.data.total;
                } else {
                    this.$message.error(res.msg || '获取积分记录失败');
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取积分记录失败');
            })
        },
        handleCurrentChange(number) {
            this.params.pageNum = number;
            this.getData();
        },
        handleSizeChange(size) {
            if (this.total_pages >= size) {
                this.params.pageSize = size;
                this.getData();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.elTableBox {
    display: flex;
    width: 100%;
}
</style>